export const getListOfCadenceCloneableTemplate = {
  GET_LIST_OF_CADENCE_CLONEABLE_TEMPLATE_REQUEST: "GET_LIST_OF_CADENCE_CLONEABLE_TEMPLATE_REQUEST",
  GET_LIST_OF_CADENCE_CLONEABLE_TEMPLATE_SUCCESS: "GET_LIST_OF_CADENCE_CLONEABLE_TEMPLATE_SUCCESS",
  GET_LIST_OF_CADENCE_CLONEABLE_TEMPLATE_ERROR: "GET_LIST_OF_CADENCE_CLONEABLE_TEMPLATE_ERROR",
};
